"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAU = exports.BASE = exports.FLOW_TYPE_INTEREST = exports.FLOW_TYPE_PRINCIPAL = exports.BondTypeDisplays = exports.Ratings = exports.CountryCodeDisplays = exports.SecurityCountryCodeDisplays = exports.SecurityStabilityTypeDisplays = exports.SecurityStabilityType = exports.SecuritySectorDisplays = exports.SecuritySector = exports.SpecialCollateralType = exports.SweepRuleType = exports.SWEEPING_TIME_BLOCK_ANY = exports.SWEEPING_TIME_BLOCK_MINUTES_SIZE = exports.flowScopeConfirmPossibleValues = exports.flowScopePaymentPossibleValues = exports.flowScopeSDIPossibleValues = exports.flowScopeTradingPossibleValues = exports.FlowScopeBits = exports.MetricTypes = exports.UNKNOWN_VALUE = void 0;
exports.UNKNOWN_VALUE = 'UNKNOWN';
var MetricTypes;
(function (MetricTypes) {
    MetricTypes["BLANK"] = "";
    MetricTypes["SURVIVAL_HORIZON"] = "Survival Horizon";
    MetricTypes["NET_BREACH"] = "Net Breach";
    MetricTypes["GROSS_BREACH"] = "Gross Breach";
    MetricTypes["LCR"] = "LCR";
    MetricTypes["HISTORICAL_BALANCE"] = "Cumulative";
    MetricTypes["HISTORICAL_BUFFER"] = "Buffer";
    MetricTypes["HISTORICAL_SURPLUS"] = "Surplus";
    MetricTypes["PASS_THROUGH_WAIT"] = "Pass Through Wait";
    MetricTypes["UNEXPECTED"] = "Unexpected";
    MetricTypes["THROUGHPUT"] = "Throughput";
    MetricTypes["FOREIGN_CURRENCY_NETFLOW"] = "Foreign Ccy Flow";
    MetricTypes["ACTUAL_BALANCE"] = "Actual Balance";
    MetricTypes["SUSPENSE_BALANCE"] = "Suspense Balance";
})(MetricTypes = exports.MetricTypes || (exports.MetricTypes = {}));
class FlowScopeBits {
}
exports.FlowScopeBits = FlowScopeBits;
FlowScopeBits.TRADING = 1;
FlowScopeBits.SDI = 2;
FlowScopeBits.PAYMENT = 4;
FlowScopeBits.CONFIRM = 8;
exports.flowScopeTradingPossibleValues = '(1, 3, 5, 7, 9, 11, 13, 15)';
exports.flowScopeSDIPossibleValues = '(2, 3, 6, 7, 10, 11, 14, 15)';
exports.flowScopePaymentPossibleValues = '(4, 5, 6, 7, 12, 13, 14, 15)';
exports.flowScopeConfirmPossibleValues = '(8, 9, 10, 11, 12, 13, 14, 15)';
exports.SWEEPING_TIME_BLOCK_MINUTES_SIZE = 30;
exports.SWEEPING_TIME_BLOCK_ANY = 9999;
var SweepRuleType;
(function (SweepRuleType) {
    SweepRuleType["BALANCE"] = "BALANCE";
    SweepRuleType["PREFUNDING"] = "PREFUND";
    SweepRuleType["TIME_SPECIFIC"] = "TIME_SPECIFIC";
})(SweepRuleType = exports.SweepRuleType || (exports.SweepRuleType = {}));
var SpecialCollateralType;
(function (SpecialCollateralType) {
    SpecialCollateralType["GC"] = "GC";
    SpecialCollateralType["SC"] = "SC";
})(SpecialCollateralType = exports.SpecialCollateralType || (exports.SpecialCollateralType = {}));
var SecuritySector;
(function (SecuritySector) {
    SecuritySector["DISC"] = "DISC";
    SecuritySector["STAP"] = "STAP";
    SecuritySector["ENRG"] = "ENRG";
    SecuritySector["FINC"] = "FINC";
    SecuritySector["HLTH"] = "HLTH";
    SecuritySector["INDS"] = "INDS";
    SecuritySector["IT"] = "IT";
    SecuritySector["MTRL"] = "MTRL";
    SecuritySector["TCOM"] = "TCOM";
    SecuritySector["UTIL"] = "UTIL";
    SecuritySector["RLES"] = "RLES";
})(SecuritySector = exports.SecuritySector || (exports.SecuritySector = {}));
exports.SecuritySectorDisplays = new Map([
    [SecuritySector.DISC, 'Consumer Discretionary'],
    [SecuritySector.STAP, 'Consumer Staples'],
    [SecuritySector.ENRG, 'Energy'],
    [SecuritySector.FINC, 'Financials'],
    [SecuritySector.HLTH, 'Health'],
    [SecuritySector.INDS, 'Industrials'],
    [SecuritySector.IT, 'IT'],
    [SecuritySector.MTRL, 'Materials'],
    [SecuritySector.TCOM, 'Telecommunications'],
    [SecuritySector.UTIL, 'Utilities'],
    [SecuritySector.RLES, 'Real Estate'],
]);
var SecurityStabilityType;
(function (SecurityStabilityType) {
    // VERY_STABLE = 'VERY_STABLE',
    // STABLE = 'STABLE',
    // LESS_STABLE = 'LESS_STABLE',
    SecurityStabilityType["VERY_STABLE"] = "Very Stable";
    SecurityStabilityType["STABLE"] = "Stable";
    SecurityStabilityType["LESS_STABLE"] = "Less Stable";
})(SecurityStabilityType = exports.SecurityStabilityType || (exports.SecurityStabilityType = {}));
exports.SecurityStabilityTypeDisplays = new Map([
    [SecurityStabilityType.VERY_STABLE, 'Very Stable'],
    [SecurityStabilityType.STABLE, 'Stable'],
    [SecurityStabilityType.LESS_STABLE, 'Less Stable'],
]);
exports.SecurityCountryCodeDisplays = new Map([
    ['DE', 'Germany'],
    ['FR', 'France'],
    ['EU', 'European Union'],
    ['IT', 'Italy'],
    ['NL', 'Netherlands'],
    ['BE', 'Belgium'],
    ['SI', 'Slovenia'],
    ['ES', 'Spain'],
    ['SE', 'Sweden'],
    ['LT', 'Lithuania'],
    ['FI', 'Finland'],
    ['AT', 'Austria'],
    ['GB', 'United Kingdom'],
    ['NO', 'Norway'],
    ['IS', 'Iceland'],
    ['DK', 'Denmark'],
    ['SK', 'Slovakia'],
    ['US', 'United States of America'],
    ['LU', 'Luxembourg'],
    ['JP', 'Japan'],
]);
exports.CountryCodeDisplays = new Map([
    ['AF', 'Afghanistan'],
    ['AX', 'Aland Islands'],
    ['AL', 'Albania'],
    ['DZ', 'Algeria'],
    ['AS', 'American Samoa'],
    ['AD', 'Andorra'],
    ['AO', 'Angola'],
    ['AI', 'Anguilla'],
    ['AQ', 'Antarctica'],
    ['AG', 'Antigua and Barbuda'],
    ['AR', 'Argentina'],
    ['AM', 'Armenia'],
    ['AW', 'Aruba'],
    ['AU', 'Australia'],
    ['AT', 'Austria'],
    ['AZ', 'Azerbaijan'],
    ['BS', 'Bahamas'],
    ['BH', 'Bahrain'],
    ['BD', 'Bangladesh'],
    ['BB', 'Barbados'],
    ['BY', 'Belarus'],
    ['BE', 'Belgium'],
    ['BZ', 'Belize'],
    ['BJ', 'Benin'],
    ['BM', 'Bermuda'],
    ['BT', 'Bhutan'],
    ['BO', 'Bolivia'],
    ['BA', 'Bosnia and Herzegovina'],
    ['BW', 'Botswana'],
    ['BV', 'Bouvet Island'],
    ['BR', 'Brazil'],
    ['VG', 'British Virgin Islands'],
    ['IO', 'British Indian Ocean Territory'],
    ['BN', 'Brunei Darussalam'],
    ['BG', 'Bulgaria'],
    ['BF', 'Burkina Faso'],
    ['BI', 'Burundi'],
    ['KH', 'Cambodia'],
    ['CM', 'Cameroon'],
    ['CA', 'Canada'],
    ['CV', 'Cape Verde'],
    ['KY', 'Cayman Islands'],
    ['CF', 'Central African Republic'],
    ['TD', 'Chad'],
    ['CL', 'Chile'],
    ['CN', 'China'],
    ['HK', 'Hong Kong, SAR China'],
    ['MO', 'Macao, SAR China'],
    ['CX', 'Christmas Island'],
    ['CC', 'Cocos (Keeling) Islands'],
    ['CO', 'Colombia'],
    ['KM', 'Comoros'],
    ['CG', 'Congo, (Brazzaville)'],
    ['CD', 'Congo, (Kinshasa)'],
    ['CK', 'Cook Islands'],
    ['CR', 'Costa Rica'],
    ['CI', 'Cote d"Ivoire'],
    ['HR', 'Croatia'],
    ['CU', 'Cuba'],
    ['CY', 'Cyprus'],
    ['CZ', 'Czech Republic'],
    ['DK', 'Denmark'],
    ['DJ', 'Djibouti'],
    ['DM', 'Dominica'],
    ['DO', 'Dominican Republic'],
    ['EC', 'Ecuador'],
    ['EG', 'Egypt'],
    ['SV', 'El Salvador'],
    ['GQ', 'Equatorial Guinea'],
    ['ER', 'Eritrea'],
    ['EE', 'Estonia'],
    ['ET', 'Ethiopia'],
    ['EU', 'European Union'],
    ['FK', 'Falkland Islands (Malvinas)'],
    ['FO', 'Faroe Islands'],
    ['FJ', 'Fiji'],
    ['FI', 'Finland'],
    ['FR', 'France'],
    ['GF', 'French Guiana'],
    ['PF', 'French Polynesia'],
    ['TF', 'French Southern Territories'],
    ['GA', 'Gabon'],
    ['GM', 'Gambia'],
    ['GE', 'Georgia'],
    ['DE', 'Germany'],
    ['GH', 'Ghana'],
    ['GI', 'Gibraltar'],
    ['GR', 'Greece'],
    ['GL', 'Greenland'],
    ['GD', 'Grenada'],
    ['GP', 'Guadeloupe'],
    ['GU', 'Guam'],
    ['GT', 'Guatemala'],
    ['GG', 'Guernsey'],
    ['GN', 'Guinea'],
    ['GW', 'Guinea-Bissau'],
    ['GY', 'Guyana'],
    ['HT', 'Haiti'],
    ['HM', 'Heard and Mcdonald Islands'],
    ['VA', 'Holy See (Vatican City State)'],
    ['HN', 'Honduras'],
    ['HU', 'Hungary'],
    ['IS', 'Iceland'],
    ['IN', 'India'],
    ['ID', 'Indonesia'],
    ['IR', 'Iran, Islamic Republic of'],
    ['IQ', 'Iraq'],
    ['IE', 'Ireland'],
    ['IM', 'Isle of Man'],
    ['IL', 'Israel'],
    ['IT', 'Italy'],
    ['JM', 'Jamaica'],
    ['JP', 'Japan'],
    ['JE', 'Jersey'],
    ['JO', 'Jordan'],
    ['KZ', 'Kazakhstan'],
    ['KE', 'Kenya'],
    ['KI', 'Kiribati'],
    ['KP', 'Korea (North)'],
    ['KR', 'Korea (South)'],
    ['KW', 'Kuwait'],
    ['KG', 'Kyrgyzstan'],
    ['LA', 'Lao PDR'],
    ['LV', 'Latvia'],
    ['LB', 'Lebanon'],
    ['LS', 'Lesotho'],
    ['LR', 'Liberia'],
    ['LY', 'Libya'],
    ['LI', 'Liechtenstein'],
    ['LT', 'Lithuania'],
    ['LU', 'Luxembourg'],
    ['MK', 'Macedonia, Republic of'],
    ['MG', 'Madagascar'],
    ['MW', 'Malawi'],
    ['MY', 'Malaysia'],
    ['MV', 'Maldives'],
    ['ML', 'Mali'],
    ['MT', 'Malta'],
    ['MH', 'Marshall Islands'],
    ['MQ', 'Martinique'],
    ['MR', 'Mauritania'],
    ['MU', 'Mauritius'],
    ['YT', 'Mayotte'],
    ['MX', 'Mexico'],
    ['FM', 'Micronesia, Federated States of'],
    ['MD', 'Moldova'],
    ['MC', 'Monaco'],
    ['MN', 'Mongolia'],
    ['ME', 'Montenegro'],
    ['MS', 'Montserrat'],
    ['MA', 'Morocco'],
    ['MZ', 'Mozambique'],
    ['MM', 'Myanmar'],
    ['NA', 'Namibia'],
    ['NR', 'Nauru'],
    ['NP', 'Nepal'],
    ['NL', 'Netherlands'],
    ['AN', 'Netherlands Antilles'],
    ['NC', 'New Caledonia'],
    ['NZ', 'New Zealand'],
    ['NI', 'Nicaragua'],
    ['NE', 'Niger'],
    ['NG', 'Nigeria'],
    ['NU', 'Niue'],
    ['NF', 'Norfolk Island'],
    ['MP', 'Northern Mariana Islands'],
    ['NO', 'Norway'],
    ['OM', 'Oman'],
    ['PK', 'Pakistan'],
    ['PW', 'Palau'],
    ['PS', 'Palestinian Territory'],
    ['PA', 'Panama'],
    ['PG', 'Papua New Guinea'],
    ['PY', 'Paraguay'],
    ['PE', 'Peru'],
    ['PH', 'Philippines'],
    ['PN', 'Pitcairn'],
    ['PL', 'Poland'],
    ['PT', 'Portugal'],
    ['PR', 'Puerto Rico'],
    ['QA', 'Qatar'],
    ['RE', 'Reunion'],
    ['RO', 'Romania'],
    ['RU', 'Russian Federation'],
    ['RW', 'Rwanda'],
    ['BL', 'Saint-Barthelemy'],
    ['SH', 'Saint Helena'],
    ['KN', 'Saint Kitts and Nevis'],
    ['LC', 'Saint Lucia'],
    ['MF', 'Saint-Martin (French part)'],
    ['PM', 'Saint Pierre and Miquelon'],
    ['VC', 'Saint Vincent and Grenadines'],
    ['WS', 'Samoa'],
    ['SM', 'San Marino'],
    ['ST', 'Sao Tome and Principe'],
    ['SA', 'Saudi Arabia'],
    ['SN', 'Senegal'],
    ['RS', 'Serbia'],
    ['SC', 'Seychelles'],
    ['SL', 'Sierra Leone'],
    ['SG', 'Singapore'],
    ['SK', 'Slovakia'],
    ['SI', 'Slovenia'],
    ['SB', 'Solomon Islands'],
    ['SO', 'Somalia'],
    ['ZA', 'South Africa'],
    ['GS', 'South Georgia and the South Sandwich Islands'],
    ['SS', 'South Sudan'],
    ['ES', 'Spain'],
    ['LK', 'Sri Lanka'],
    ['SD', 'Sudan'],
    ['SR', 'Suriname'],
    ['SJ', 'Svalbard and Jan Mayen Islands'],
    ['SZ', 'Swaziland'],
    ['SE', 'Sweden'],
    ['CH', 'Switzerland'],
    ['SY', 'Syrian Arab Republic (Syria)'],
    ['TW', 'Taiwan, Republic of China'],
    ['TJ', 'Tajikistan'],
    ['TZ', 'Tanzania, United Republic of'],
    ['TH', 'Thailand'],
    ['TL', 'Timor-Leste'],
    ['TG', 'Togo'],
    ['TK', 'Tokelau'],
    ['TO', 'Tonga'],
    ['TT', 'Trinidad and Tobago'],
    ['TN', 'Tunisia'],
    ['TR', 'Turkey'],
    ['TM', 'Turkmenistan'],
    ['TC', 'Turks and Caicos Islands'],
    ['TV', 'Tuvalu'],
    ['UG', 'Uganda'],
    ['UA', 'Ukraine'],
    ['AE', 'United Arab Emirates'],
    ['GB', 'United Kingdom'],
    ['US', 'United States of America'],
    ['UM', 'US Minor Outlying Islands'],
    ['UY', 'Uruguay'],
    ['UZ', 'Uzbekistan'],
    ['VU', 'Vanuatu'],
    ['VE', 'Venezuela (Bolivarian Republic)'],
    ['VN', 'Viet Nam'],
    ['VI', 'Virgin Islands, US'],
    ['WF', 'Wallis and Futuna Islands'],
    ['EH', 'Western Sahara'],
    ['YE', 'Yemen'],
    ['ZM', 'Zambia'],
    ['ZW', 'Zimbabwe'],
]);
exports.Ratings = [
    'A1',
    'Baa2',
    'Aaa',
    'A3 ',
    'Aa2',
    'Baa1',
    'Aa3',
    'Aa1',
    'A2',
];
exports.BondTypeDisplays = new Map([
    ['SOVEREIGN', 'Sovereign'],
    ['GENERIC', 'Generic'],
]);
exports.FLOW_TYPE_PRINCIPAL = 'PRINCIPAL';
exports.FLOW_TYPE_INTEREST = 'INTEREST';
exports.BASE = 'BASE';
exports.BAU = 'BAU';
// export const STRESS_SCENARIO_TYPES = [
//     BAU,
//     'STRESS_SCENARIO_1',
//     'STRESS_SCENARIO_2',
//     'STRESS_SCENARIO_3',
//     'STRESS_SCENARIO_4',
//     'STRESS_SCENARIO_5',
// ];
//# sourceMappingURL=constants.js.map